import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import Masonry from '@mui/lab/Masonry';
import { Close } from '@mui/icons-material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../features/dialog';
import { clearPreview } from '../../../features/job';
import PostCard from '../../post/PostCard';
import { numberFormat } from 'highcharts';

const DIALOG_ID = "jobPreview"

function JobPreviewDialog() {
    const dispatch = useDispatch();
    const show = !!useSelector((state) => state.dialog[DIALOG_ID]);
    const preview = useSelector(state => state.job.preview);
    const { loading, data, error } = preview;

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
        dispatch(clearPreview());
    }

    const totalResults = data?.totalResults || 0;
    const posts = data?.posts || [];
    const totalFormatted = numberFormat(totalResults, 0, ".", ",");

    return (
        <Dialog
            open={!!show}
            onClose={onClose}
            fullWidth
            maxWidth="xl"
            PaperProps={{
                sx: { height: '90vh' }
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Job Preview Results</Typography>
                <Button onClick={onClose} startIcon={<Close />} size="small">
                    Close Preview
                </Button>
            </DialogTitle>
            
            <DialogContent dividers>
                {loading && (
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <LinearProgress />
                        <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                            Loading preview results...
                        </Typography>
                    </Box>
                )}

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        Error loading preview: {error}
                    </Alert>
                )}

                {data && !loading && (
                    <Box>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Preview shows <strong>{totalFormatted}</strong> total results in the last 30 days
                            {posts.length > 0 && ` (displaying ${posts.length} sample posts)`}
                        </Typography>

                        {posts.length === 0 && !error && (
                            <Alert severity="info">
                                No posts found with the current search criteria.
                            </Alert>
                        )}

                        {posts.length > 0 && (
                            <Masonry columns={5} spacing={2}>
                                {posts.map((post, index) => (
                                    <Box key={post.uuid || index} minHeight={220}>
                                        <PostCard post={post} intent="preview" />
                                    </Box>
                                ))}
                            </Masonry>
                        )}
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} startIcon={<Close />} size="small">
                    Close Preview
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default JobPreviewDialog;